import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './page/home';
import ThankYou from './page/thankyou';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
